import { IconButton, Tooltip } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import moment from "moment";
import { Link } from "react-router-dom";
import { API_URLS } from "src/api/apiUrls";
import DeleteDialog from "src/components/delete-dialog/DeleteDialog";
import Iconify from "src/components/iconify/iconify";
import { useBoolean } from "src/hooks/use-boolean";
import Restricted from "src/PermissionProvider/Restricted";
import { AdminType } from "src/types/admins";
import { PrmsEnum } from "src/types/permissions";

// ----------------------------------------------------------------------

type Props = {
  row: AdminType;
};

export default function AdminsTableRow ({ row }: Props) {
  const confirmDelete = useBoolean();

  return (
    <TableRow hover>
      <TableCell sx={{ whiteSpace: "nowrap", textAlign: "center" }}>
        <Typography>{row.roleId}</Typography>
      </TableCell>
      <TableCell sx={{ whiteSpace: "nowrap", textAlign: "center" }}>
        <Typography>{row.role.displayName}</Typography>
      </TableCell>
      <TableCell sx={{ whiteSpace: "nowrap", textAlign: "center" }}>
        <Typography>{row.fullName}</Typography>
      </TableCell>
      <TableCell sx={{ whiteSpace: "nowrap", textAlign: "center" }}>
        <Typography color={row.active ? "green" : "red"}>
          {row.active ? "Active" : "Inactive"}
        </Typography>
      </TableCell>
      <TableCell sx={{ whiteSpace: "nowrap", textAlign: "center" }}>
        <Typography>{moment(row.updatedAt).format("YYYY-MM-DD")}</Typography>
      </TableCell>
      <TableCell sx={{ whiteSpace: "nowrap", textAlign: "center" }}>
        <Restricted to={PrmsEnum.DELETE_ADMIN}>
          <Tooltip title='Delete' placement='bottom' arrow>
            <IconButton onClick={confirmDelete.onTrue}>
              <Iconify
                icon='material-symbols:delete-outline'
                width='27'
                height='27'
                color='#FFAB8B'
              />
            </IconButton>
          </Tooltip>
        </Restricted>
        <Restricted to={PrmsEnum.UPDATE_ADMIN}>
          <Tooltip title='Edit' placement='bottom' arrow>
            <Link to={`admins/${row.id}`}>
              <IconButton onClick={confirmDelete.onTrue}>
                <Iconify
                  icon='ri:edit-2-line'
                  width='27'
                  height='27'
                  color='#FFAB8B'
                />
              </IconButton>
            </Link>
          </Tooltip>
        </Restricted>
      </TableCell>
      {/* Confirm */}
      <DeleteDialog
        open={confirmDelete.value}
        onClose={confirmDelete.onFalse}
        name='admin'
        url={API_URLS.ADMINS}
        id={row.id}
      />
    </TableRow>
  );
}
